<template>
  <div>
    <div class="Home">
      <section class="Home__navbar" :class="nav_classes" aria-label="Nitto Pit Crew">
        <h1>
          <span class="sr-only">Nitto Tire</span>
          <svg aria-hidden="true" width="198" height="17" viewBox="0 0 198 17" fill="none" focusable="false" role="img" aria-label="Nitto" xmlns="http://www.w3.org/2000/svg">
          <path d="M55.1222 6.74367L48.399 16.4594H65.3566L65.3766 16.4195L72.0599 6.74367H55.1222Z" fill="white"/>
          <path d="M29.5262 1.29729H10.4539L7.9202 4.98806H32.419L29.5262 1.29729Z" fill="white"/>
          <path d="M174.943 6.74367C174.963 7.10278 174.863 7.48183 174.623 7.88083L173.147 10.2748C172.17 11.8709 169.257 13.0679 166.663 12.9482C164.09 12.8085 162.793 11.432 163.771 9.85589L165.247 7.46188C165.406 7.20253 165.606 6.98308 165.845 6.76362H149.327C149.227 6.88332 149.127 7.02298 149.027 7.16263C148.948 7.26238 148.888 7.36213 148.808 7.46188C148.788 7.50178 148.768 7.52173 148.728 7.56163C148.648 7.66138 148.589 7.78108 148.509 7.88083C148.489 7.92073 148.469 7.94068 148.449 7.98058C148.369 8.08033 148.309 8.20003 148.249 8.29978C148.229 8.33968 148.209 8.35963 148.19 8.39953C148.13 8.51924 148.05 8.61899 147.99 8.73869C147.97 8.75864 147.95 8.79854 147.93 8.83844C147.87 8.95814 147.81 9.05789 147.751 9.17759C147.731 9.19754 147.731 9.23744 147.711 9.25739C147.651 9.37709 147.591 9.49679 147.551 9.59654C147.531 9.61649 147.531 9.65639 147.511 9.67634C147.451 9.79604 147.411 9.91574 147.372 10.0354C147.372 10.0554 147.352 10.0753 147.352 10.0953C147.312 10.215 147.272 10.3347 147.232 10.4743C147.232 10.4943 147.232 10.4943 147.232 10.5142C146.953 11.4918 146.933 12.4295 147.312 13.2873C147.312 13.3073 147.312 13.3073 147.332 13.3272C147.392 13.4669 147.471 13.6265 147.571 13.7661C149.247 16.2998 160.778 16.5392 165.965 16.5392C171.152 16.5392 183.681 15.6614 186.653 13.3871C189.047 11.5517 191.022 9.25739 191.242 6.80352H174.943V6.74367Z" fill="white"/>
          <path d="M191.062 4.90826C191.042 4.84841 191.022 4.80851 191.003 4.74866L190.943 4.58906H190.923C189.706 1.73619 183.721 1.29729 171.551 1.29729C160.379 1.29729 153.397 2.7337 150.903 4.98806H191.082C191.062 4.96811 191.062 4.92821 191.062 4.90826Z" fill="white"/>
          <path d="M6.70324 6.74367L0 16.4594H16.9576L22.0249 9.11774L27.0723 16.4394L27.0524 16.4594H43.99L50.7132 6.74367H6.70324Z" fill="white"/>
          <path d="M87.581 6.74367L81.197 16.0404L80.8978 16.4594H97.8554L102.643 9.67634L94.1845 6.74367H87.581Z" fill="white"/>
          <path d="M120 6.74367L113.317 16.4594H130.274L135.062 9.67634L126.603 6.74367H120Z" fill="white"/>
          <path d="M51.8903 5.00801L54.4638 1.29729H37.5062L34.9526 4.98806L51.8903 5.00801Z" fill="white"/>
          <path d="M58.8529 1.29729L56.3192 4.98806H56.3391L73.2569 5.00801H73.2768L75.8304 1.29729H58.8529Z" fill="white"/>
          <path d="M148.17 5.00801L150.763 1.29729H80.2394L77.6858 4.98806L148.17 5.00801Z" fill="white"/>
          <path d="M194.813 0.539185C196.309 0.539185 197.506 1.75614 197.506 3.27235C197.506 4.80851 196.309 6.02547 194.813 6.02547C193.317 6.02547 192.1 4.82846 192.1 3.27235C192.1 1.75614 193.317 0.539185 194.813 0.539185ZM194.813 0.978087C193.596 0.978087 192.618 2.01549 192.618 3.2923C192.618 4.58906 193.596 5.60652 194.813 5.60652C196.03 5.62647 197.007 4.58906 197.007 3.2923C197.007 1.99554 196.03 0.978087 194.813 0.978087ZM193.815 4.86836V1.81599C194.075 1.77609 194.314 1.75614 194.673 1.75614C195.132 1.75614 195.451 1.85589 195.631 1.99554C195.81 2.13519 195.91 2.3347 195.91 2.63395C195.91 3.03295 195.631 3.27235 195.312 3.3721V3.39205C195.571 3.43195 195.771 3.6913 195.83 4.13021C195.89 4.60901 195.97 4.78856 196.03 4.88831H195.531C195.451 4.78856 195.392 4.50926 195.332 4.11026C195.252 3.7312 195.052 3.5716 194.673 3.5716H194.334V4.86836H193.815ZM194.294 3.1726H194.653C195.052 3.1726 195.392 3.03295 195.392 2.6539C195.392 2.3746 195.192 2.11524 194.653 2.11524C194.494 2.11524 194.394 2.13519 194.294 2.13519V3.1726Z" fill="white"/>
          </svg>
          <span class="h2">Pit Crew</span>
        </h1>
      </section>
      <section class="Home__hero" aria-label="Represent, Join Pit Crew">
        <div class="Home__hero-content">
          <h2 class="h1">Represent<br> <span class="Home__hero-content-text-shadow d-block pt-lg-2"><small class="d-block">Join</small>Pit Crew</span></h2>
          <b-button class="mb-4 show-desktop btn-double-outline btn-double-outline--normal" tabindex="0" :to="'personal-info'" @click="() => trackCustomEvent('Home', 'Click', 'Apply Now')" variant="primary">Apply Now</b-button>
          <b-button class="mb-4 hide-desktop btn-double-outline btn-double-outline--reverse" tabindex="0" :to="'personal-info'" @click="() => trackCustomEvent('Home', 'Click', 'Apply Now')" variant="secondary">Apply Now</b-button>
          <p>Got a set of Nittos? We want to hear from you. Hit apply now</p>
        </div>
      </section>
      <section class="Home__social" aria-label="#PITCREWFOMO, The Club Fueled by enthusiasts">
        <h2 class="h1">#PITCREWFOMO</h2>
        <div class="Home__social-bg"></div>
        <div class="Home__social-content">
          <h3 class="h2">The Club Fueled by Enthusiasts</h3>
          <b-button class="mb-4 btn-double-outline btn-double-outline--reverse" tabindex="0" :to="'personal-info'" @click="() => trackCustomEvent('Home', 'Click', 'Send It')" variant="secondary">Send it!</b-button>
        </div>
      </section>
    </div>
    <footer>
      <ul>
        <li>
          <span>&copy;{{ current_year }} Nitto Tire U.S.A. Inc</span> |
        </li>
        <li>
          <a class="text-underline" aria-label="Privacy Policy (link opens in a new tab.)" href="https://www.nittotire.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> |
        </li>
        <li>
          <a class="text-underline" aria-label="Terms &amp; Conditions (link opens in a new tab.)" href="https://www.nittotire.com/terms/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> |
        </li>
        <li>
          <a class="text-underline" href="#" role="button" aria-haspopup="dialog" data-faux="c-settings">Cookie Settings</a>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import { throttle } from 'lodash-es';
import { trackCustomEvent } from '../utils/tracking';

export default {
  name: 'home',
  data() {
    return {
      scroll_top: null,
      current_year: new Date().getFullYear(),
    };
  },
  computed: {
    nav_classes() {
      return {
        'Home__navbar--dark': this.scroll_top > 0,
      };
    },
  },
  mounted() {
    window.addEventListener('scroll', throttle(this.handleSrollTop, 50), false);

    document.title = 'Home | Nitto Pit Crew';
  },
  destroyed() {
    window.removeEventListener('scroll', throttle(this.handleSrollTop, 50), false);
  },
  methods: {
    handleSrollTop() {
      this.scroll_top = window.scrollY;
    },
    trackCustomEvent(category = '', action = '', label = '', value = null) {
      trackCustomEvent(category, action, label, value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../assets/styles/_breakpoints.scss';

.Home {
  text-align: center;

  &__hero {
    background: url('../assets/images/home-bg.jpg') no-repeat bottom center;
    background-size: cover;
    min-height: 768px;

    @include media-breakpoint-down(sm) {
      background: url('../assets/images/home-bg-m.jpg') no-repeat top center;
      min-height: 630px;
    }
  }

  &__hero-content {
    padding: 150px 0 60px;

    @include media-breakpoint-down(sm) {
      padding: 100px 0 40px;
    }

    .h1 {
      text-transform: uppercase;
      // color: #000;

      @include media-breakpoint-down(sm) {
        color: white;
        margin-bottom: 30px;
      }
    }

    p {
      max-width: 320px;
      margin: 0 auto;
    }
  }
  &__hero-content-text-shadow {
    text-transform: uppercase;
      color: white;
      font-size: 72px;
      line-height: .95;
      text-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8);
      margin-bottom: 300px;

      @include media-breakpoint-down(sm) {
        margin-bottom: 350px;
        font-size: 42px;
      }

      small {
        font-size: 42px;
        display: block;

        @include media-breakpoint-down(sm) {
          font-size: 28px;
        }
      }
  }

  &__navbar {
    background: rgba(0,0,0,0.5);
    height: 88px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;
    transition: background 240ms ease-in-out;

    @include media-breakpoint-down(sm) {
      height: 68px;
    }

    svg {
      height: 16px;

      @include media-breakpoint-down(sm) {
        height: 12px;
      }
    }

    span.h2 {
      display: block;
      font-size: 30px;
      line-height: .5;
      text-transform: uppercase;

      @include media-breakpoint-down(sm) {
        font-size: 18px;
      }
    }

    h1 {
      margin-bottom: 0;
      line-height: 1;
    }

    &--dark {
      background: black;
    }
  }

  &__social {
    h2.h1 {
      margin-bottom: 70px;

      @include media-breakpoint-down(sm) {
        font-size: 32px;
      }
    }
  }

  &__social-bg {
    background: url('../assets/images/social-bg.jpg') no-repeat top center;
    background-size: cover;
    min-height: 600px;

    @include media-breakpoint-down(sm) {
      background: url('../assets/images/social-bg-m.jpg') no-repeat top center;
      min-height: 570px;
      background-size: cover;
    }
  }

  &__social-content {
    margin-top: -50px;
    transform: translateY(-75%);

    @include media-breakpoint-down(sm) {
      margin-top: -100px;
      transform: translateY(-100%);
    }

    h3 {
      max-width: 320px;
      margin: 0 auto 18px;
      text-transform: uppercase;
    }
  }

  .btn {
    min-width: 275px;
  }

  .show-desktop {
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  .hide-desktop {
    display: none;
    @include media-breakpoint-down(sm) {
      display: inline-block;
    }
  }
}

footer {
  ul {
    list-style: none;
    text-align: center;
  }

  li {
    display: inline-block;
    padding-right: 10px;
  }

  a, span, button {
    color: white;
    font-size: 14px;
  }
  button {
    @extend %roboto-font-regular;
    border: none;
    text-transform: none;
    &:focus {
      box-shadow: 0 0 0 1px white;
      border-radius: 0;
    }
  }
}

</style>
